import React from "react";
import { Star, Quote } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 text-slate-800 text-xs font-semibold mb-4 border border-yellow-200">
            Wat klanten zeggen
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 text-balance">
            Tevreden klanten, mooie wanden.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div key={t.name} className="relative rounded-2xl border border-slate-200 bg-white p-6 hover-lift">
              <Quote className="absolute top-5 right-5 w-8 h-8 text-yellow-300" />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed">“{t.text}”</p>
              <div className="mt-5 pt-4 border-t border-slate-100">
                <div className="font-semibold text-slate-900">{t.name}</div>
                <div className="text-sm text-slate-500">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
